export const sensorSourceLinks = [
  { label: "Intel RealSense D455 specs", url: "https://www.intel.com/content/www/us/en/products/sku/205847/intel-realsense-depth-camera-d455/specifications.html" },
  { label: "RealSense camera pricing", url: "https://www.realsenseai.com/compare-all-cameras/" },
  { label: "Luxonis OAK-D Lite store", url: "https://shop.luxonis.com/products/oak-d-lite-1" },
  { label: "Stereolabs ZED 2i store", url: "https://www.stereolabs.com/store/products/zed-2i" },
  { label: "Basler ace 2 product line", url: "https://www.baslerweb.com/en/cameras/ace2/" },
  { label: "Prophesee EVK4 HD", url: "https://www.prophesee.ai/event-camera-evk4/" },
  { label: "FLIR Boson distributor listing", url: "https://groupgets.com/collections/boson" },
  { label: "RobotShop RPLIDAR A1M8", url: "https://eu.robotshop.com/products/rplidar-a1m8-360-degree-laser-scanner-development-kit" },
  { label: "Generation Robots Hokuyo UST-10LX", url: "https://www.generationrobots.com/en/401755-hokuyo-ust-10lx-scanning-laser-range-finder.html" },
  { label: "RS SICK TiM571", url: "https://nl.rs-online.com/web/p/light-detection-and-ranging/2133822" },
  { label: "Ouster OS0 product page", url: "https://ouster.com/products/hardware/os0-lidar-sensor" },
  { label: "Reichelt Ouster OS0 distributor listing", url: "https://www.reichelt.com/de/en/shop/product/ouster_multi-layer_3d-lidar_os0_rev7_128_layer_90_0_-_100_m-363167" },
  { label: "ATI Mini45 product page", url: "https://ati.novanta.com/product/mini45-force-torque-sensor/" },
  { label: "Bota Systems MiniONE store", url: "https://shop.botasys.com/shop/minione-gen-a-2162" },
  { label: "Robotiq FT 300-S", url: "https://robotiq.com/products/ft-300-force-torque-sensor" },
  { label: "RS Robotiq FT 300-S listing", url: "https://us.rs-online.com/product/robotiq/fts-300-s-omron-kit/71650129/" },
  { label: "Bosch BNO055 product page", url: "https://www.bosch-sensortec.com/en/products/smart-sensor-systems/bno055/" },
  { label: "DigiKey Bosch BNO055", url: "https://www.digikey.com/en/products/detail/bosch-sensortec/BNO055/6136301" },
  { label: "VectorNav VN-100", url: "https://www.vectornav.com/products/detail/vn-100" },
  { label: "NavTechGPS VN-100 development kit", url: "https://www.navtechgps.com/vn-100-rugged-development-kit/" },
  { label: "ST VL53L1X", url: "https://www.st.com/en/imaging-and-photonics-solutions/vl53l1x.html" },
  { label: "Adafruit VL53L1X breakout", url: "https://www.adafruit.com/product/3967" },
  { label: "MaxBotix robot sensors", url: "https://maxbotix.com/blogs/blog/ultrasonic-sensor-on-robot" },
  { label: "RobotShop MaxBotix MB1202", url: "https://www.robotshop.com/products/maxbotix-mb1202-i2cxl-maxsonar-ez0-high-performance-ultrasonic-module" },
  { label: "Renishaw RESOLUTE encoder", url: "https://www.renishaw.com/en/resolute-optical-absolute-encoder-series--37823" },
  { label: "Same Sky AMT102-V", url: "https://www.sameskydevices.com/product/motion-and-control/rotary-encoders/incremental/modular/amt102-v" },
  { label: "SICK nanoScan3 product information", url: "https://www.sick.com/media/docs/5/75/075/product_information_nanoscan3_en_im0087075.pdf" },
  { label: "Lesman SICK nanoScan3 listing", url: "https://www.lesman.com/nans3-aaaz30an1" },
  { label: "Omron F3SG-SR at DigiKey", url: "https://www.digikey.com/en/product-highlight/o/omron-automation-and-safety/f3sg-sr-safety-light-curtain" },
  { label: "Banner safety light curtains", url: "https://www.bannerengineering.com/us/en/products/machine-safety/safety-light-curtains.html" },
  { label: "GelSight Mini", url: "https://www.gelsight.com/gelsightmini/" },
  { label: "GelSight DIGIT tactile sensor", url: "https://www.gelsight.com/product/digit-tactile-sensor/" },
  { label: "XELA tactile sensing", url: "https://xelarobotics.com/technology/" },
  { label: "Shadow Robot sensors", url: "https://shadowrobot.com/sensors/" }
];

export const robotSensorFamilies = [
  {
    group: "Robot vision sensors",
    eyebrow: "Cameras",
    image: "/images/sensors/vision-camera.svg",
    imageAlt: "Abstract local illustration of robot camera sensors for RGB, stereo, depth and thermal vision",
    summary: "Vision sensors give robots color, shape, motion, texture and heat cues. They usually sit on the head, mast, wrist, gripper, mobile base or inspection payload. The hard part is not only camera selection. It is lighting, calibration, lens choice, synchronization and software that can tell uncertainty from a real object.",
    items: [
      {
        name: "RGB cameras",
        measures: "Visible color and texture.",
        where: "Head, mast, wrist, cell fixture or gripper.",
        why: "Supports labels, human presence detection, teleoperation views, object detection and visual inspection.",
        useCase: "A warehouse robot can use RGB vision to read package markings while another depth sensor estimates shape.",
        examples: "Basler ace 2 industrial cameras, USB machine vision cameras, embedded RGB modules.",
        limits: "Lighting changes, glare, privacy, motion blur, lens contamination and rolling shutter artifacts.",
        buyingChecks: "Check shutter type, lens mount, frame rate, SDK support, trigger input, cable length and lighting plan."
      },
      {
        name: "Stereo cameras",
        measures: "Depth from two camera views.",
        where: "Robot head, mobile robot mast, drone front plate or outdoor inspection payload.",
        why: "They can provide depth without projecting light and can work where active depth cameras struggle.",
        useCase: "A delivery robot can estimate curb geometry and obstacle distance with a stereo baseline and calibrated lenses.",
        examples: "Stereolabs ZED 2i, ZED X, Intel RealSense stereo depth cameras.",
        limits: "Textureless walls, bad calibration, vibration, lens mismatch and low light reduce depth quality.",
        buyingChecks: "Check baseline, IP rating, ROS support, synchronization, global shutter needs and compute load."
      },
      {
        name: "Depth cameras",
        measures: "Distance maps through stereo, structured light or time of flight.",
        where: "Robot wrist, picking cell, humanoid head, AMR mast or lab bench.",
        why: "Depth makes grasp planning, bin picking, obstacle detection and scene geometry easier.",
        useCase: "A robot arm can combine depth and RGB to segment an object before a gripper closes.",
        examples: "Intel RealSense D455, Luxonis OAK-D Lite, time of flight modules.",
        limits: "Sunlight, transparent objects, reflective parts, black materials and multipath can break measurements.",
        buyingChecks: "Check range, minimum distance, depth noise, USB bandwidth, power, ROS driver maturity and enclosure."
      },
      {
        name: "Global shutter cameras",
        measures: "Images without line-by-line rolling distortion.",
        where: "Fast robot wrists, moving conveyors, drone payloads and inspection cells.",
        why: "Global shutter helps when the robot or target moves quickly.",
        useCase: "A high speed inspection robot can avoid distorted images when tracking moving parts on a conveyor.",
        examples: "Basler ace 2 global shutter cameras with Sony Pregius sensors.",
        limits: "Cost, lens choice and lighting still matter. Global shutter does not solve bad exposure.",
        buyingChecks: "Check exposure time, trigger latency, lens, lighting, frame rate at full resolution and SDK licensing."
      },
      {
        name: "Event cameras",
        measures: "Pixel brightness changes instead of full frames.",
        where: "Fast drones, robot tracking rigs, high speed manipulation labs and industrial vibration monitoring.",
        why: "They can react to fast motion with low latency and high dynamic range.",
        useCase: "A research robot can track fast moving objects where a normal camera blurs or misses the event.",
        examples: "Prophesee EVK4 HD with Sony IMX636, CenturyArks SilkyEvCam.",
        limits: "They require specialized algorithms and are harder to explain to non-vision teams.",
        buyingChecks: "Check SDK, event format, ROS integration, calibration tools, lighting and whether the task truly needs event data."
      },
      {
        name: "Thermal cameras",
        measures: "Long wave infrared heat patterns.",
        where: "Inspection robots, drones, firefighting robots, energy inspection payloads and security robots.",
        why: "They see heat in darkness, smoke or low visible light where RGB cameras fail.",
        useCase: "A plant inspection robot can detect overheating motors or electrical cabinets without touching them.",
        examples: "Teledyne FLIR Boson, FLIR Lepton modules.",
        limits: "Lower detail than RGB, export rules, thermal reflections, calibration drift and higher cost.",
        buyingChecks: "Check resolution, radiometric output, lens, export restrictions, frame rate, enclosure and thermal calibration."
      }
    ]
  },
  {
    group: "LiDAR and mapping sensors",
    eyebrow: "Laser range sensing",
    image: "/images/sensors/lidar-mapping.svg",
    imageAlt: "Abstract local illustration of LiDAR beams around a mobile robot",
    summary: "LiDAR measures distance with laser scanning. A 2D LiDAR can be enough for indoor AMR navigation, while 3D LiDAR is useful for uneven terrain, mapping, outdoor perception and inspection. Safety LiDAR is different because it is certified for protective fields and machine safety.",
    items: [
      {
        name: "2D LiDAR",
        measures: "Planar distance around the robot.",
        where: "Low front bumper, AMR mast, AGV side panel or indoor robot base.",
        why: "Provides reliable obstacle geometry for indoor navigation and local mapping.",
        useCase: "An AMR can use a 2D LiDAR for SLAM and obstacle avoidance in a warehouse aisle.",
        examples: "RPLIDAR A1M8, Hokuyo UST-10LX, SICK TiM series.",
        limits: "It sees one slice of the world and can miss table edges, forks, cables and objects above or below the scan plane.",
        buyingChecks: "Check range, angular resolution, sunlight tolerance, scan rate, interface, ROS driver and mounting height."
      },
      {
        name: "3D LiDAR",
        measures: "Point clouds across vertical and horizontal fields of view.",
        where: "Vehicle roof, robot dog back, outdoor robot mast or mapping payload.",
        why: "Maps slopes, racks, pallets, people and outdoor geometry for robot navigation.",
        useCase: "A quadruped inspection robot can map stairs, pipes and platforms with 3D point clouds.",
        examples: "Ouster OS0, Hesai lidar sensors, Velodyne legacy units.",
        limits: "Cost, power draw, data rate, rain, dust, glass, reflective surfaces and multi-sensor calibration.",
        buyingChecks: "Check vertical FOV, range on low reflectivity targets, point rate, IP rating, time sync and data bandwidth."
      },
      {
        name: "Safety LiDAR",
        measures: "Certified protective and warning zones.",
        where: "Front and rear of AGVs, AMRs and industrial mobile platforms.",
        why: "It is used to slow or stop machines when people enter a defined hazard zone.",
        useCase: "A mobile platform can reduce speed in a warning zone and stop in a protective zone near workers.",
        examples: "SICK nanoScan3, Pilz PSENscan.",
        limits: "Safety validation, dirty optics, reflective objects, blind zones and wrong zone configuration.",
        buyingChecks: "Check safety rating, protective field range, response time, zone sets, wiring, diagnostics and local safety standards."
      },
      {
        name: "Mapping LiDAR",
        measures: "Geometry for SLAM, localization and 3D maps.",
        where: "Survey payload, mobile mapping rig, outdoor robot or autonomous vehicle test platform.",
        why: "Provides geometric structure for maps, localization and digital twins.",
        useCase: "A facility mapping robot can combine LiDAR, IMU and wheel odometry to build a map before fleet deployment.",
        examples: "Ouster OS0, Hesai XT series, Hokuyo industrial scanners.",
        limits: "Featureless corridors, glass, dust and poor time synchronization can degrade the map.",
        buyingChecks: "Check timestamping, ROS 2 support, calibration targets, mounting vibration and processing pipeline."
      }
    ]
  },
  {
    group: "Force, torque and tactile sensors",
    eyebrow: "Touch and contact",
    image: "/images/sensors/force-tactile.svg",
    imageAlt: "Abstract local illustration of a robot wrist force torque sensor and tactile fingertip",
    summary: "Force, torque and tactile sensors tell the robot what contact feels like. They matter when a robot must insert a part, sand a surface, close a gripper gently, recover from slip or learn contact rich manipulation. This is one of the hardest sensor families because the signal depends on mechanics, calibration and control loops.",
    items: [
      {
        name: "Wrist force torque sensors",
        measures: "Forces and torques along six axes at the robot wrist.",
        where: "Between the robot flange and the end effector.",
        why: "Enables force control, assembly, deburring, sanding, insertion and safer contact detection.",
        useCase: "A cobot can keep a near constant contact force while polishing a curved part.",
        examples: "ATI Mini45, Bota MiniONE, OnRobot HEX, Robotiq FT 300-S.",
        limits: "Payload overload, thermal drift, cable strain, tool mass compensation and robot controller integration.",
        buyingChecks: "Check force range, overload rating, interface, tool flange, sampling rate, ROS support and calibration workflow."
      },
      {
        name: "Joint torque sensing",
        measures: "Torque inside or around a robot joint.",
        where: "Inside the actuator module, gearbox output or elastic element.",
        why: "Estimates contact and regulates compliant motion for legged robots, cobots and humanoids.",
        useCase: "A legged robot can adjust foot contact when torque feedback shows unexpected ground reaction.",
        examples: "Torque sensors in robot joints, series elastic actuator sensing, motor current based estimates.",
        limits: "Gear friction, backlash, temperature and motor current estimates can hide true contact forces.",
        buyingChecks: "Check sensor location, bandwidth, calibration method, overload behavior and controller access."
      },
      {
        name: "Tactile fingertip sensors",
        measures: "Contact geometry, pressure, local deformation or slip cues.",
        where: "Fingertips, gripper pads, robot hand phalanges or soft skins.",
        why: "Improves grasp stability, dexterous manipulation and Physical AI data collection.",
        useCase: "A robot hand can detect that a smooth object is slipping before it falls.",
        examples: "GelSight DIGIT, GelSight Mini, XELA uSkin, Shadow Robot tactile sensors.",
        limits: "Wear, gel replacement, wiring, calibration, data volume and fragile contact surfaces.",
        buyingChecks: "Check mounting space, contact material, replacement parts, sampling rate, APIs and whether the hand can use the signal."
      },
      {
        name: "Gripper force sensing",
        measures: "Grip force or contact pressure at the fingers.",
        where: "Inside gripper fingers, fingertips or jaw mechanism.",
        why: "Reduces crushing risk and improves repeatability with uncertain objects.",
        useCase: "A packaging robot can grip soft items with lower force when contact is detected early.",
        examples: "Force sensitive resistors, strain gauges, load cells, gripper integrated sensing.",
        limits: "Local contact only, drift, hysteresis and poor correlation between finger force and object stability.",
        buyingChecks: "Check resolution, overload, sensor placement, cable routing and how the gripper controller exposes the data."
      }
    ]
  },
  {
    group: "IMU, balance and motion sensors",
    eyebrow: "Motion state",
    image: "/images/sensors/imu-motion.svg",
    imageAlt: "Abstract local illustration of IMU motion axes on a robot body",
    summary: "IMUs measure acceleration and angular velocity. Some units include magnetometers, barometers or onboard fusion. Drones, humanoids and quadrupeds depend on motion sensing, but IMU data drifts and must be fused with encoders, cameras, LiDAR, GNSS or contact sensors.",
    items: [
      {
        name: "Accelerometers",
        measures: "Linear acceleration and gravity direction.",
        where: "Main body, head, limb module, drone flight controller or payload.",
        why: "Estimates tilt, impacts, vibration and movement.",
        useCase: "A humanoid controller can detect a body acceleration spike during a stumble.",
        examples: "Bosch Sensortec MEMS sensors, TDK InvenSense IMUs.",
        limits: "Vibration, bias, shock saturation and gravity separation during motion.",
        buyingChecks: "Check range, noise density, bandwidth, bias stability and mounting vibration isolation."
      },
      {
        name: "Gyroscopes",
        measures: "Angular velocity.",
        where: "Robot torso, mobile base, drone autopilot or manipulator payload.",
        why: "Estimates orientation changes between external sensor updates.",
        useCase: "A drone can stabilize attitude using high rate gyro data between camera frames.",
        examples: "TDK InvenSense ICM series, VectorNav VN-100, MicroStrain 3DM-GX5.",
        limits: "Bias drift, temperature effects and integration error over time.",
        buyingChecks: "Check bias stability, temperature calibration, update rate, time sync and interface."
      },
      {
        name: "Magnetometers",
        measures: "Magnetic field direction.",
        where: "Inside IMU packages or navigation modules.",
        why: "They can support heading estimation in clean magnetic environments.",
        useCase: "A small field robot may use magnetometer heading when GNSS and visual landmarks are weak.",
        examples: "9 axis IMUs such as Bosch BNO055 and TDK InvenSense ICM-20948.",
        limits: "Motors, steel structures, current loops and indoor machinery can corrupt heading.",
        buyingChecks: "Check calibration tools, magnetic environment and whether the robot can operate without magnetometer trust."
      },
      {
        name: "Industrial IMU and AHRS modules",
        measures: "Acceleration, angular rate and orientation with stronger calibration.",
        where: "Outdoor mobile robots, autonomous vehicles, drones and mapping payloads.",
        why: "They reduce drift compared with low cost chips and provide cleaner data for navigation.",
        useCase: "A mapping robot can fuse IMU with LiDAR for smoother localization through vibration.",
        examples: "VectorNav VN-100, LORD MicroStrain 3DM-GX5.",
        limits: "Cost, setup complexity and calibration assumptions.",
        buyingChecks: "Check calibration grade, data protocol, ROS support, GNSS needs, shock rating and connector type."
      }
    ]
  },
  {
    group: "Proximity and distance sensors",
    eyebrow: "Near field detection",
    image: "/images/sensors/proximity-distance.svg",
    imageAlt: "Abstract local illustration of short range distance sensors around a robot gripper",
    summary: "Proximity sensors are simple, cheap and often more reliable than complex perception for one narrow job. They can tell a gripper that a part is present, a robot cell that a fixture is loaded or a small robot that an obstacle is close. Their weakness is that every technology has blind spots.",
    items: [
      {
        name: "Time of flight sensors",
        measures: "Short range distance using light time of flight.",
        where: "Small grippers, mobile robot edges, embedded devices and human interface modules.",
        why: "They are compact and useful for simple ranging where a full depth camera is too large.",
        useCase: "A small mobile robot can detect a nearby wall before the bumper touches it.",
        examples: "ST VL53L1X, Adafruit VL53L1X breakout.",
        limits: "Sunlight, glass, reflectivity, range limits and small field of view.",
        buyingChecks: "Check range, field of view, cover glass, I2C address conflicts and ambient light conditions."
      },
      {
        name: "Ultrasonic sensors",
        measures: "Distance from sound reflections.",
        where: "Low cost robots, bins, tanks, parking style obstacle sensing and mobile bases.",
        why: "They are cheap and can work with materials that confuse optical sensors.",
        useCase: "A service robot can use ultrasonic modules as slow speed backup obstacle detection.",
        examples: "MaxBotix ultrasonic modules.",
        limits: "Wide beam, soft materials, air temperature, cross talk and low angular resolution.",
        buyingChecks: "Check beam pattern, update rate, minimum range, enclosure, temperature compensation and mounting angle."
      },
      {
        name: "Infrared proximity sensors",
        measures: "Nearby objects through reflected infrared light.",
        where: "Grippers, small robots, conveyors and edge detection modules.",
        why: "They are simple and low cost for close detection.",
        useCase: "A line robot can detect whether a small part is present before a pick attempt.",
        examples: "IR reflective sensors, photoelectric sensors from Omron, Keyence and Banner.",
        limits: "Black surfaces, sunlight, transparent objects and target reflectivity.",
        buyingChecks: "Check target material, sensing mode, range, cable type, output type and background suppression."
      },
      {
        name: "Capacitive and inductive sensors",
        measures: "Presence of materials through electric or electromagnetic fields.",
        where: "Factory cells, grippers, fixtures, mobile base bumpers and part feeders.",
        why: "Inductive sensors are strong for metal detection. Capacitive sensors can detect some nonmetallic materials.",
        useCase: "An industrial robot cell can verify that a metal workpiece is seated before a welding cycle.",
        examples: "ifm, Omron, Keyence and Banner proximity sensors.",
        limits: "Very short range, material dependency, mounting sensitivity and false triggers from nearby metal.",
        buyingChecks: "Check sensing distance, target material, shielded or unshielded body, IP rating and electrical output."
      }
    ]
  },
  {
    group: "Encoders and joint position sensors",
    eyebrow: "Position feedback",
    image: "/images/sensors/encoder-position.svg",
    imageAlt: "Abstract local illustration of an encoder disk inside a robot joint",
    summary: "Encoders tell the robot where a shaft, wheel or joint is. A robot arm without good position feedback cannot hold accurate paths. A mobile base without encoder feedback cannot estimate wheel motion. Encoders look simple, but mounting, alignment, cable noise and absolute reference matter more than many beginners expect.",
    items: [
      {
        name: "Absolute encoders",
        measures: "Position without needing a homing move after power on.",
        where: "Robot joints, precision rotary stages, CNC axes and high value actuators.",
        why: "They reduce startup risk and preserve position after power cycles.",
        useCase: "A robot arm joint can know its angle immediately after the controller boots.",
        examples: "Renishaw RESOLUTE, Heidenhain absolute rotary encoders.",
        limits: "Cost, installation tolerance, contamination, protocol compatibility and mechanical alignment.",
        buyingChecks: "Check protocol, resolution, accuracy, mounting tolerance, environmental rating and controller support."
      },
      {
        name: "Incremental encoders",
        measures: "Relative motion through pulses and index marks.",
        where: "Motors, wheels, conveyors, mobile bases and lower cost robot joints.",
        why: "They are affordable and common for speed and position feedback.",
        useCase: "A differential drive robot can estimate wheel motion with two incremental encoders.",
        examples: "Same Sky AMT102-V, Broadcom reflective optical encoder chips.",
        limits: "Need homing or index reference, missed pulses and electrical noise.",
        buyingChecks: "Check counts per revolution, shaft fit, index channel, output type, cable shielding and controller input."
      },
      {
        name: "Magnetic encoders",
        measures: "Shaft angle using a magnet and magnetic sensing IC.",
        where: "Compact joints, hobby actuators, grippers and mobile robot wheels.",
        why: "They are compact and tolerate dust better than many optical encoders.",
        useCase: "A compact gripper can use magnetic angle feedback where optical alignment is difficult.",
        examples: "AMS magnetic encoder ICs, integrated magnetic motor encoders.",
        limits: "Magnet alignment, stray magnetic fields, temperature and lower precision than high end optical systems.",
        buyingChecks: "Check magnet spacing, resolution, absolute or incremental output, temperature and nearby motors."
      },
      {
        name: "Optical encoders",
        measures: "Position through light patterns on a code disk or scale.",
        where: "Industrial arms, precision stages, motors and machine automation.",
        why: "They can provide high resolution and repeatable feedback.",
        useCase: "A precision robot arm axis can use optical feedback for accurate path tracking.",
        examples: "Renishaw optical encoder systems, Heidenhain rotary encoders, Broadcom optical encoder devices.",
        limits: "Dust, oil, alignment, shock and optical contamination.",
        buyingChecks: "Check sealing, mounting method, readhead gap, output protocol and maintenance access."
      }
    ]
  },
  {
    group: "Safety sensors for industrial robots",
    eyebrow: "Machine safety",
    image: "/images/sensors/safety-sensors.svg",
    imageAlt: "Abstract local illustration of robot safety zones, light curtains and emergency stop systems",
    summary: "Safety sensors are not ordinary perception sensors. They protect people and machines under defined standards, wiring and validated logic. A vision model that detects humans is not a replacement for a certified safety circuit in an industrial cell.",
    items: [
      {
        name: "Safety scanners",
        measures: "Protected zones around moving machines.",
        where: "AGVs, AMRs, robot cell entrances and industrial mobile bases.",
        why: "They can slow or stop machines when a person enters a hazardous area.",
        useCase: "An AGV can switch between warning and stop zones depending on speed and aisle geometry.",
        examples: "SICK nanoScan3, Pilz PSENscan.",
        limits: "Certification scope, dirty optics, reflective surfaces, wrong field setup and blind corners.",
        buyingChecks: "Check safety category, protective range, response time, zone switching, diagnostics and local compliance."
      },
      {
        name: "Safety light curtains",
        measures: "Interrupted beams across a machine access point.",
        where: "Robot cells, presses, conveyors and loading stations.",
        why: "They create a protective screen without a physical door.",
        useCase: "A robot cell can stop when an operator reaches through a loading opening.",
        examples: "Omron F3SG-SR, Banner safety light curtains, Keyence safety curtains.",
        limits: "They only cover the protected plane. They need correct muting, reset logic and risk assessment.",
        buyingChecks: "Check resolution, height, range, safety rating, muting needs, alignment and controller wiring."
      },
      {
        name: "Emergency stop and enabling systems",
        measures: "Manual safety commands rather than environmental data.",
        where: "Teach pendants, cell panels, robot bases and remote control stations.",
        why: "They give humans a direct stop or enabling control during setup and abnormal operation.",
        useCase: "A technician can use an enabling switch while jogging a robot at reduced speed.",
        examples: "Pilz, Omron, SICK and Banner safety control hardware.",
        limits: "Incorrect wiring, bypassed circuits and confusing reset procedures.",
        buyingChecks: "Check safety relay compatibility, stop category, dual channel wiring, diagnostics and maintenance process."
      },
      {
        name: "Collision detection sensors",
        measures: "Unexpected contact through torque, force, current or dedicated collision modules.",
        where: "Robot joints, wrists, end effectors and collaborative robot controllers.",
        why: "They support safer physical interaction and damage reduction, but they do not replace a full safety assessment.",
        useCase: "A cobot can stop when measured joint torque exceeds an allowed contact threshold.",
        examples: "Joint torque sensing, force torque sensors and safety rated robot controller functions.",
        limits: "Pinch points, payload estimation errors, tool mass and response time.",
        buyingChecks: "Check whether the function is safety rated, how payload is configured and how stops are validated."
      }
    ]
  },
  {
    group: "Tactile sensors and robot skin",
    eyebrow: "Robot skin",
    image: "/images/sensors/tactile-skin.svg",
    imageAlt: "Abstract local illustration of tactile skin patches on a robot hand",
    summary: "Tactile skin is still an emerging field. It can provide local pressure, shear, contact location or high resolution surface geometry. The promise is large for humanoid hands and Physical AI, but integration is hard because robot skin needs wiring, protection, calibration, replacement parts and software that can use dense touch data.",
    items: [
      {
        name: "Fingertip tactile sensors",
        measures: "Contact patches, geometry, deformation or pressure at the fingertip.",
        where: "Robot hands and small gripper fingertips.",
        why: "Detects slip, corrects grasp errors and improves object handling.",
        useCase: "A research hand can collect touch data while turning a small object inside the fingers.",
        examples: "GelSight DIGIT, GelSight Mini, research tactile fingertips.",
        limits: "Wear, gel replacement, lighting inside the sensor and contact surface damage.",
        buyingChecks: "Check sensor size, mounting, replacement gels, SDK, cable strain relief and data rate."
      },
      {
        name: "Pressure arrays",
        measures: "Distributed pressure over a patch.",
        where: "Gripper pads, palms, fingers, robot skins and collaborative tooling.",
        why: "Maps where contact happens instead of reporting only total force.",
        useCase: "A gripper can detect whether the object is centered or only touching one edge.",
        examples: "XELA uSkin and custom pressure array integrations.",
        limits: "Durability, wiring density, calibration drift and resolution limits.",
        buyingChecks: "Check taxel count, update rate, force range, covering material, cleaning and replacement process."
      },
      {
        name: "Soft robotics sensors",
        measures: "Stretch, pressure, bend or deformation in compliant structures.",
        where: "Soft grippers, inflatable actuators, wearable robots and compliant robot skins.",
        why: "Rigid sensors often fail when the robot body itself bends or deforms.",
        useCase: "A soft gripper can estimate finger bending as it wraps around a fragile object.",
        examples: "Piezoresistive, capacitive, optical and fluidic soft sensors.",
        limits: "Hysteresis, drift, fragile conductors and hard calibration.",
        buyingChecks: "Check material compatibility, bending cycles, sealing, calibration and repair method."
      },
      {
        name: "Humanoid hand sensing",
        measures: "Contact, force, slip and finger state across a hand.",
        where: "Fingertips, phalanges, palm and wrist.",
        why: "Humanoid manipulation needs more than cameras because many errors happen after contact.",
        useCase: "A humanoid hand can adjust grip after detecting that the object has shifted during lift.",
        examples: "Shadow Robot tactile sensors, XELA skin integrations, GelSight based research sensors.",
        limits: "Cable routing, replacement cost, skin durability, data volume and controller access.",
        buyingChecks: "Check whether the hand exposes tactile data, how sensors are replaced and if software can learn from the signals."
      }
    ]
  }
];

export const sensorPriceRows = [
  {
    type: "Depth camera",
    product: "Intel RealSense D455",
    use: "Robot wrist vision, AMR perception, lab 3D sensing",
    price: "$419",
    currency: "USD",
    source: "RealSenseAI camera comparison page",
    sourceUrl: "https://www.realsenseai.com/compare-all-cameras/",
    lastChecked: "2026-07-01",
    notes: "Public store style price. Intel product page may not load pricing in every region."
  },
  {
    type: "AI depth camera",
    product: "Luxonis OAK-D Lite",
    use: "Embedded RGB plus stereo depth with onboard vision processing",
    price: "$169",
    currency: "USD",
    source: "Luxonis official store",
    sourceUrl: "https://shop.luxonis.com/products/oak-d-lite-1",
    lastChecked: "2026-07-01",
    notes: "Public unit price from manufacturer store."
  },
  {
    type: "Stereo camera",
    product: "Stereolabs ZED 2i",
    use: "Stereo vision, robot spatial perception, outdoor and indoor testing",
    price: "$499",
    currency: "USD",
    source: "Stereolabs official store",
    sourceUrl: "https://www.stereolabs.com/store/products/zed-2i",
    lastChecked: "2026-07-01",
    notes: "Polarizer option listed separately by Stereolabs."
  },
  {
    type: "Thermal camera module",
    product: "FLIR Boson 320",
    use: "Thermal inspection, drones, rescue robots, industrial monitoring",
    price: "from $1,539",
    currency: "USD",
    source: "GroupGets FLIR Boson distributor listing",
    sourceUrl: "https://groupgets.com/collections/boson",
    lastChecked: "2026-07-01",
    notes: "Distributor price, not a manufacturer MSRP. Export restrictions may apply."
  },
  {
    type: "Event camera",
    product: "Prophesee EVK4 HD",
    use: "High speed motion, event based tracking, robotics research",
    price: "request quote",
    currency: "n/a",
    source: "Prophesee EVK4 HD product page",
    sourceUrl: "https://www.prophesee.ai/event-camera-evk4/",
    lastChecked: "2026-07-01",
    notes: "Official page describes the evaluation kit but does not show a public price."
  },
  {
    type: "Low cost 2D LiDAR",
    product: "RPLIDAR A1M8",
    use: "Education, prototyping, indoor SLAM experiments",
    price: "€108.90",
    currency: "EUR",
    source: "RobotShop EU listing",
    sourceUrl: "https://eu.robotshop.com/products/rplidar-a1m8-360-degree-laser-scanner-development-kit",
    lastChecked: "2026-07-01",
    notes: "Distributor sale price, tax included on EU listing."
  },
  {
    type: "Industrial 2D LiDAR",
    product: "Hokuyo UST-10LX",
    use: "Indoor mobile robots, obstacle detection, navigation",
    price: "€1,878.00",
    currency: "EUR",
    source: "Generation Robots listing",
    sourceUrl: "https://www.generationrobots.com/en/401755-hokuyo-ust-10lx-scanning-laser-range-finder.html",
    lastChecked: "2026-07-01",
    notes: "Distributor price, VAT included on the listing."
  },
  {
    type: "Industrial 2D LiDAR",
    product: "SICK TiM571-2050101",
    use: "Outdoor detection, industrial monitoring, mobile robots",
    price: "€2,439.31 incl VAT",
    currency: "EUR",
    source: "RS Netherlands listing",
    sourceUrl: "https://nl.rs-online.com/web/p/light-detection-and-ranging/2133822",
    lastChecked: "2026-07-01",
    notes: "Distributor price. Listed excluding VAT at €2,015.96."
  },
  {
    type: "3D LiDAR",
    product: "Ouster OS0 Rev 7 128",
    use: "3D perception, mapping, robotics, warehouse automation",
    price: "€17,690",
    currency: "EUR",
    source: "Reichelt distributor listing",
    sourceUrl: "https://www.reichelt.com/de/en/shop/product/ouster_multi-layer_3d-lidar_os0_rev7_128_layer_90_0_-_100_m-363167",
    lastChecked: "2026-07-01",
    notes: "Distributor price for one OS0 Rev 7 128 configuration. Other channels and configurations differ."
  },
  {
    type: "6 axis force torque sensor",
    product: "Bota Systems MiniONE Gen A",
    use: "Compact wrist force sensing, research, manipulation",
    price: "CHF 3,045.00",
    currency: "CHF",
    source: "Bota Systems official store",
    sourceUrl: "https://shop.botasys.com/shop/minione-gen-a-2162",
    lastChecked: "2026-07-01",
    notes: "Manufacturer online store price for MiniONE Gen A variant."
  },
  {
    type: "6 axis force torque sensor",
    product: "ATI Mini45",
    use: "Industrial force control, assembly, testing, automation",
    price: "request quote",
    currency: "n/a",
    source: "ATI product page",
    sourceUrl: "https://ati.novanta.com/product/mini45-force-torque-sensor/",
    lastChecked: "2026-07-01",
    notes: "Official page describes the sensor. Public manufacturer price was not listed."
  },
  {
    type: "6 axis force torque kit",
    product: "Robotiq FT 300-S OMRON kit",
    use: "Cobot force control and contact rich manipulation",
    price: "$6,992.28",
    currency: "USD",
    source: "RS United States listing",
    sourceUrl: "https://us.rs-online.com/product/robotiq/fts-300-s-omron-kit/71650129/",
    lastChecked: "2026-07-01",
    notes: "Distributor price for a specific kit, not a generic FT 300-S price."
  },
  {
    type: "Consumer MEMS IMU chip",
    product: "Bosch BNO055",
    use: "Low cost orientation experiments and embedded prototypes",
    price: "€11.25",
    currency: "EUR",
    source: "DigiKey listing",
    sourceUrl: "https://www.digikey.com/en/products/detail/bosch-sensortec/BNO055/6136301",
    lastChecked: "2026-07-01",
    notes: "Bosch marks BNO055 as not recommended for new designs."
  },
  {
    type: "Industrial IMU development kit",
    product: "VectorNav VN-100 Rugged Development Kit",
    use: "Navigation development, AHRS testing, mapping payloads",
    price: "$1,200 to $1,525",
    currency: "USD",
    source: "NavTechGPS listing",
    sourceUrl: "https://www.navtechgps.com/vn-100-rugged-development-kit/",
    lastChecked: "2026-07-01",
    notes: "Distributor listing for a development kit with calibration options."
  },
  {
    type: "Time of flight distance sensor",
    product: "Adafruit VL53L1X breakout",
    use: "Small robot distance checks, gripper sensing, prototypes",
    price: "$14.95",
    currency: "USD",
    source: "Adafruit listing",
    sourceUrl: "https://www.adafruit.com/product/3967",
    lastChecked: "2026-07-01",
    notes: "Breakout board price, not raw ST component price."
  },
  {
    type: "Ultrasonic sensor",
    product: "MaxBotix MB1202",
    use: "Short range obstacle detection and distance sensing",
    price: "$44.95",
    currency: "USD",
    source: "RobotShop listing",
    sourceUrl: "https://www.robotshop.com/products/maxbotix-mb1202-i2cxl-maxsonar-ez0-high-performance-ultrasonic-module",
    lastChecked: "2026-07-01",
    notes: "Distributor price. Stock and tariff notes can change."
  },
  {
    type: "Incremental encoder",
    product: "Same Sky AMT102-V",
    use: "Motor feedback, mobile bases, lab actuators",
    price: "$34.23",
    currency: "USD",
    source: "Same Sky product page",
    sourceUrl: "https://www.sameskydevices.com/product/motion-and-control/rotary-encoders/incremental/modular/amt102-v",
    lastChecked: "2026-07-01",
    notes: "Manufacturer web price for quantity one."
  },
  {
    type: "Absolute encoder",
    product: "Renishaw RESOLUTE",
    use: "High precision motion axes, robot joints, metrology systems",
    price: "request quote",
    currency: "n/a",
    source: "Renishaw product page",
    sourceUrl: "https://www.renishaw.com/en/resolute-optical-absolute-encoder-series--37823",
    lastChecked: "2026-07-01",
    notes: "Official page describes performance. Public price depends on ring, readhead and interface."
  },
  {
    type: "Safety laser scanner",
    product: "SICK nanoScan3 NANS3-AAAZ30AN1",
    use: "AGV and AMR protective fields",
    price: "$3,517.99",
    currency: "USD",
    source: "Lesman distributor listing",
    sourceUrl: "https://www.lesman.com/nans3-aaaz30an1",
    lastChecked: "2026-07-01",
    notes: "Distributor price for one part number. Validate safety design with the manufacturer."
  },
  {
    type: "Safety light curtain",
    product: "Omron F3SG-4SRA0560-14",
    use: "Robot cell access protection and machine guarding",
    price: "$2,502.36",
    currency: "USD",
    source: "DigiKey product highlight",
    sourceUrl: "https://www.digikey.com/en/product-highlight/o/omron-automation-and-safety/f3sg-sr-safety-light-curtain",
    lastChecked: "2026-07-01",
    notes: "Example part number and height. Full systems need correct emitter, receiver, wiring and safety logic."
  },
  {
    type: "Tactile fingertip sensor",
    product: "GelSight DIGIT",
    use: "Robot hand research, in hand manipulation, tactile datasets",
    price: "$355.00",
    currency: "USD",
    source: "GelSight official store",
    sourceUrl: "https://www.gelsight.com/product/digit-tactile-sensor/",
    lastChecked: "2026-07-01",
    notes: "Official store price. Lead time shown separately by GelSight."
  },
  {
    type: "Tactile surface sensor",
    product: "GelSight Mini",
    use: "Surface texture, tactile inspection, robotics research",
    price: "$510",
    currency: "USD",
    source: "GelSight Mini product page",
    sourceUrl: "https://www.gelsight.com/gelsightmini/",
    lastChecked: "2026-07-01",
    notes: "Official public price. Replacement gels and cables are separate."
  },
  {
    type: "Robot skin",
    product: "XELA uSkin",
    use: "Tactile patches for fingers, palms and robot surfaces",
    price: "request quote",
    currency: "n/a",
    source: "XELA Robotics product inquiry page",
    sourceUrl: "https://xelarobotics.com/technology/",
    lastChecked: "2026-07-01",
    notes: "XELA asks buyers to request pricing and specifications for the application."
  }
];

export const sensorBuyingChecklist = [
  "Define the task before the sensor mapping, grasping, safety, inspection, balance, localization or quality control.",
  "Measure the real environment sunlight, dust, water, vibration, reflective parts, transparent objects, metal frames, people and cleaning process.",
  "Check integration early power, connector, cable bend radius, ROS 2 driver, SDK, time synchronization and calibration tools.",
  "Budget for mechanical design brackets, lenses, protective windows, lighting, vibration isolation and spare parts often cost more than expected.",
  "Do not treat a perception demo as a safety system. Certified safety sensors and validated safety logic are separate engineering work.",
  "Plan failure detection dirty lens, loose cable, dead pixels, encoder dropout, IMU drift, LiDAR rain noise, tactile gel wear and thermal calibration drift."
];

export const sensorFailureModes = [
  { title: "Cameras", text: "Fail with glare, low light, rolling shutter, lens dirt, vibration, privacy constraints and poor calibration." },
  { title: "Depth cameras", text: "Struggle with sunlight, transparent objects, black surfaces, reflective parts and multipath reflections." },
  { title: "LiDAR", text: "Can degrade with glass, rain, fog, dust, reflective tape, sparse geometry and bad timestamping." },
  { title: "Force torque sensors", text: "Can drift with temperature, cable strain, overload, wrong tool mass and poor zeroing." },
  { title: "IMUs", text: "Drift over time and react badly to vibration, magnetic interference, shock and weak temperature calibration." },
  { title: "Encoders", text: "Fail through missed counts, cable noise, contamination, misalignment and homing errors." },
  { title: "Safety sensors", text: "Fail as a system when zones, response time, wiring, reset logic or risk assessment are wrong." },
  { title: "Tactile sensors", text: "Wear mechanically and can be hard to protect from dirt, sharp objects, cable fatigue and calibration drift." }
];

export const sensorFaq = [
  {
    question: "What sensors are used in robots?",
    answer: "Robots use cameras, LiDAR, depth sensors, force torque sensors, tactile sensors, IMUs, encoders, proximity sensors, safety scanners and sometimes thermal, radar, sonar or chemical sensors. The right set depends on the task and environment."
  },
  {
    question: "What sensors do humanoid robots use?",
    answer: "Humanoid robots usually combine RGB or depth cameras, IMUs, joint encoders, motor current sensing, foot or wrist force sensors and sometimes tactile hands. Public demos do not always reveal every sensor or autonomy level."
  },
  {
    question: "What is the difference between LiDAR and depth cameras?",
    answer: "LiDAR scans distance with lasers and is strong for mapping and navigation. Depth cameras estimate nearby geometry through stereo, structured light or time of flight and are common for manipulation, picking and short range perception."
  },
  {
    question: "How much do robot sensors cost?",
    answer: "Small proximity or IMU sensors can cost under $50. Depth cameras often sit in the hundreds. Industrial LiDAR, safety scanners, force torque sensors and thermal cameras can cost thousands. Prices change often and vary by region and configuration."
  },
  {
    question: "What sensors are used in robot arms?",
    answer: "Robot arms use encoders in every joint, motor current sensing, limit switches, thermal sensors, sometimes joint torque sensing and wrist force torque sensors. Vision and depth cameras are often added near the cell or wrist for picking and inspection."
  },
  {
    question: "What sensors are used in AMRs?",
    answer: "AMRs often use 2D LiDAR, safety scanners, wheel encoders, IMUs, RGB or depth cameras and sometimes 3D LiDAR. Industrial AMRs also need safety rated sensing and validated stop behavior."
  },
  {
    question: "What sensors are used in grippers?",
    answer: "Grippers can use jaw position sensing, motor current, force sensors, tactile fingertips, vacuum pressure sensors and proximity sensors. The sensor should be chosen around the object, not only the gripper model."
  },
  {
    question: "What is a force torque sensor?",
    answer: "A force torque sensor measures forces and moments, usually along six axes. Mounted at a robot wrist, it helps the robot regulate contact during insertion, sanding, assembly, polishing and compliant manipulation."
  },
  {
    question: "Why do robots need encoders?",
    answer: "Encoders tell the controller where a joint, wheel or motor shaft is. Without position feedback, a robot cannot repeat paths, control speed accurately or estimate its body state reliably."
  },
  {
    question: "Which robot sensors are expensive?",
    answer: "High end 3D LiDAR, certified safety scanners, industrial force torque sensors, precision encoders, thermal cameras and specialized tactile skins are usually expensive compared with simple IMUs or short range distance sensors."
  }
];
